import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'underscore';
@Pipe({
    name: 'sortBy',
    pure: true,
    standalone: false
})
export class SortByPipe implements PipeTransform {

  transform(value: any, field, type = 'asc'): any {
    if (!value || !field) {
      return value;
    }
    if (type === 'asc') {      
      return _.sortBy(value, field);

    } else {
      return _.sortBy(value, field).reverse();

    }
  }

}
